import DragAndDropFile from "@/appComponents/Blocks/Composites/FileDropZone/DragAndDropFile";
import { useTopic } from "@/hooks/useTopic";
import { appstr } from "@coreapp/utils/appstr";
import type { UploadFileInfo } from "@coreapp/utils/DoUploadStatus";
import { DialogContent, Flex, Text } from "@theorgchartdev/storybook";
import type { DynamicTextProps } from "@theorgchartdev/storybook/dist/components/Text/DynamicText";

interface FileUploadCompletePayload {
  success: boolean;
  fileInfo: UploadFileInfo;
}

interface UploadYourLogoProps {
  uploadedLogo: UploadFileInfo | null;
  setUploadedLogo: (info: UploadFileInfo | null) => void;
}

const logoCaptionDynamic: DynamicTextProps = {
  template: appstr("brandedBackgroundTemplate"),
  replaceDict: { helpdocument: appstr("help document") },
  formatConfig: {
    helpdocument: {
      type: "custom",
      render: text => (
        <a
          href="https://theorgchart.zendesk.com/hc/en-us/articles/28202574958100-Creating-and-updating-backgrounds"
          target="_blank"
          rel="noreferrer"
          data-testid="brand-setup-help-link"
        >
          {text}
        </a>
      )
    }
  }
};

const UploadYourLogo = ({ uploadedLogo, setUploadedLogo }: UploadYourLogoProps) => {
  useTopic("FileUploadComplete", (data: unknown) => {
    const { success, fileInfo } = data as FileUploadCompletePayload;
    if (success && fileInfo?.fileName) {
      setUploadedLogo(fileInfo);
    }
  });

  const handleDelete = () => {
    setUploadedLogo(null);
  };

  const files = uploadedLogo ? [uploadedLogo.fileName] : [];

  return (
    <DialogContent customContentClass="oc-brand-setup-content">
      <Flex direction="column" gap="8px">
        <Text size="large" modifier="medium">
          {appstr("Upload your logo")}
        </Text>
        <Text dynamic={logoCaptionDynamic}>{appstr("brandedBackgroundMessage")}</Text>
      </Flex>
      <DragAndDropFile
        files={files}
        onDelete={handleDelete}
        targetDirectory="System"
        allowedExtensions={["png", "jpg", "jpeg"]}
        maxFiles={1}
      />
    </DialogContent>
  );
};

export default UploadYourLogo;
